import { Animated, Text, View } from 'react-native';
import { Image } from 'expo-image';
import { IDLE_COIN_SOURCE } from '../../constants/assets';
import { LayeredAvatarView } from '../avatars/LayeredAvatarLab/LayeredAvatarView';
import { ONBOARDING_HOOK } from '../../src/tutorial/constants/onboardingContent.constants';
import { DEFAULT_ONBOARDING_FIT } from '../../src/tutorial/helpers/onboardingGear.helper';
import { EXPO_IMAGE_ALT_DECORATIVE } from '../../src/shared/constants/expoImageAlt.constants';
import { useTutorialEntrance } from '../../src/tutorial/hooks/useTutorialEntrance';
import { OnboardingHeadline } from './OnboardingHeadline';
import type { OnboardingSceneProps } from './onboardingScene.types';
import { coreActionArtStyles as styles } from './CoreActionArt.styles';

/** Screen 1 — Hook: your mascot + floating "YOUR CALL" pick card, then the headline. */
export function CoreActionArt({ isActive, layout, headline, subheadline }: OnboardingSceneProps) {
  const hero = useTutorialEntrance(isActive, 60);

  return (
    <View style={styles.scene}>
      <Animated.View
        style={[styles.heroGroup, { opacity: hero.opacity, transform: [{ scale: hero.scale }] }]}
      >
        <LayeredAvatarView equipped={DEFAULT_ONBOARDING_FIT} size={layout.hookMascot} rounded={false} />
        <View style={styles.callCard}>
          <Text style={styles.callLabel}>{ONBOARDING_HOOK.callLabel}</Text>
          <Text style={styles.callMatchup}>{ONBOARDING_HOOK.matchup}</Text>
          <View style={styles.rewardPill}>
            <Image
              source={IDLE_COIN_SOURCE}
              style={styles.rewardCoin}
              contentFit="contain"
              alt={EXPO_IMAGE_ALT_DECORATIVE}
            />
            <Text style={styles.rewardText}>
              +{ONBOARDING_HOOK.rewardCoins} coins {ONBOARDING_HOOK.rewardSuffix}
            </Text>
          </View>
        </View>
      </Animated.View>

      <View style={styles.headlineWrap}>
        <OnboardingHeadline
          isActive={isActive}
          title={headline}
          subtitle={subheadline}
          delayMs={150}
        />
      </View>
    </View>
  );
}
